var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "user"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {}, [_c('legend', [_vm._v("Trip Details ")]), _vm._v(" "), _c('div', {
    staticClass: "card-headerfrm",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.SearchSrId),
      expression: "SearchSrId"
    }],
    ref: "SearchSrId",
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "Search by User id. ",
      "autocomplete": "off",
      "id": "SearchSrId",
      "name": "SearchSrId"
    },
    domProps: {
      "value": (_vm.SearchSrId)
    },
    on: {
      "keyup": _vm.SearchTripdata,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.SearchSrId = $event.target.value
      }
    }
  }), _vm._v(" "), _c('b-input-group-append', [_c('b-button', {
    staticStyle: {
      "border-radius": "0px",
      "background-color": "#f0f3f5",
      "border": "1px solid #c2cfd6"
    },
    on: {
      "click": _vm.getAllTripList
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }, [_vm._v(" Search ")])])], 1)], 1)], 1)], 1)]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), ((_vm.userRoles.rolename == 'admin' || _vm.userRolesFE.includes('admin')) || (_vm.userRoles.rolename == 'rto executive' || _vm.userRolesFE.includes('rto executive'))) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Action")])]) : _vm._e()])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.tripResultData), function(data, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.tripid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.srname))]), _vm._v(" "), (data.tripstate == 'closed') ? _c('td', [_c('b', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v(" " + _vm._s(data.tripstate))])]) : _c('td', [_c('b', {
      staticStyle: {
        "color": "green"
      }
    }, [_vm._v(" " + _vm._s(data.tripstate))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("changeDateFormat")(data.createdAt)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.vehicleno))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.openkm))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.closekm))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("changeDateFormat")(data.updatedAt)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.lastmodifiedby))]), _vm._v(" "), ((_vm.userRoles.rolename == 'admin' || _vm.userRolesFE.includes('admin')) || (_vm.userRoles.rolename == 'rto executive' || _vm.userRolesFE.includes('rto executive')) || (_vm.userRoles.rolename == 'rto executive_dayendcloser' || _vm.userRolesFE.includes('rto executive_dayendcloser'))) ? _c('td', [_c('a', {
      staticStyle: {
        "cursor": "pointer",
        "color": "#262626"
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.getTrip(data.tripid)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-eye"
    })])]) : _vm._e()])
  }), _vm._v(" "), (_vm.resultCount == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "11",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e()], 2)]), _c('br'), _vm._v(" "), _c('paginate', {
    ref: "paginate",
    attrs: {
      "page-count": _vm.pagecount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1)])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg"
    },
    on: {
      "ok": function($event) {
        _vm.TripPop == false
      }
    },
    model: {
      value: (_vm.TripPop),
      callback: function($$v) {
        _vm.TripPop = $$v
      },
      expression: "TripPop"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.ispoptripLoading
    },
    on: {
      "update:active": function($event) {
        _vm.ispoptripLoading = $event
      }
    }
  }), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-group TripPopup1"
  }, [_c('b-card', [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle",
    staticStyle: {
      "color": "#fff"
    }
  }, [_vm._v(" Trip Details ")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeTripmodel
    }
  }, [_vm._v("x")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("SR Name : ")]), _vm._v(" "), _c('b-input-group', [_vm._v("\n                      " + _vm._s(_vm.Tripsingle.srname) + "\n                  ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Trip State : ")]), _vm._v(" "), _c('b-input-group', [_vm._v("\n                      " + _vm._s(_vm.Tripsingle.tripstate) + "\n                  ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Vehicle No : ")]), _vm._v(" "), _c('b-input-group', [_vm._v("\n                      " + _vm._s(_vm.Tripsingle.vehicleno) + "\n                  ")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Open KM")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "350px"
    },
    attrs: {
      "src": _vm.openKmImg,
      "alt": ""
    },
    on: {
      "error": function($event) {
        return _vm.loadOpenImageError(_vm.openKmImg)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 mt-3"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-road'></i>"
    }
  }, [_c('b-input-group', [_c('input', {
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Open KM",
      "id": "openkm",
      "name": "openKm",
      "readonly": ""
    },
    domProps: {
      "value": _vm.Tripsingle.openkm
    }
  })])], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Close KM")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "350px"
    },
    attrs: {
      "src": _vm.closeKmImg,
      "alt": ""
    },
    on: {
      "error": function($event) {
        return _vm.loadCloseImageError(_vm.closeKmImg)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 mt-3"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-ship'></i>"
    }
  }, [(_vm.Tripsingle.tripstate == 'closed') ? _c('input', {
    ref: "closekm",
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.Tripsingle.closekm
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.closekm),
      expression: "closekm"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        isValidNumber: true,
        isValidKM: true,
        isValidDistance: true
      }),
      expression: "{required: true,isValidNumber:true,isValidKM:true,isValidDistance:true}"
    }],
    ref: "closekm",
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter close km ",
      "autocomplete": "off",
      "id": "closekm",
      "name": "closekm"
    },
    domProps: {
      "value": (_vm.closekm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.closekm = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('closekm')),
      expression: "errors.has('closekm')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('closekm')))])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(" Reason : ")]), _c('span', {
    staticClass: "text-danger"
  }), _vm._v(" "), _c('b-input-group', [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-ship'></i>"
    }
  }, [_c('Multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'error': _vm.errors.has('tripreason')
    },
    staticStyle: {
      "z-index": "999",
      "border": "1px solid #c2cfd6"
    },
    attrs: {
      "disabled": _vm.Tripsingle.tripstate == 'closed',
      "options": _vm.getAllReasons,
      "name": "tripreason",
      "id": "tripreason",
      "placeholder": "Select Reason",
      "custom-label": _vm.customLabel
    },
    model: {
      value: (_vm.tripreason),
      callback: function($$v) {
        _vm.tripreason = $$v
      },
      expression: "tripreason"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('tripreason')),
      expression: "errors.has('tripreason')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('tripreason')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "1.8rem"
    }
  }, [_c('b-button', {
    staticClass: "btn btn-success mr-2",
    attrs: {
      "disabled": _vm.Tripsingle.tripstate == 'closed',
      "type": "submit"
    }
  }, [_vm._v("Close Trip")])], 1)])])], 1)])], 1)], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Sr No.")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Trip Id")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Sr Name")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Trip State")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Created Date")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Vehicle No")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Open Km")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Close Km")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Modified Date")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Modified By")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27d76b96","hasScoped":false}!./src/views/components/ForceCloseTrip/ForceCloseTrip.component.html
// module id = 1272
// module chunks = 1